import * as React from "react";
import Csrf from "../commons/model/Csrf";

interface CsrfInputProps {
  csrf: Csrf;
}

export default class CsrfInput extends React.Component<CsrfInputProps> {
  render() {
    const { parameter, token } = this.props.csrf;
    return <input type="hidden" name={parameter} value={token} />;
  }
}
